import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";

@Component({
  selector: 'app-whats-on-list',
  templateUrl: './whats-on-list.component.html'
})
export class WhatsOnListComponent implements OnInit {

  public slug;

  banner_image = './assets/images/banners/what-on-banner.jpg';

  category = {
    id: '',
    title: '',
    content: '',
    cover_image: ''
  };

  events = [];

  regions = [];
  allRegions: Array<any>;
  regionsPart: Array<any>;
  regionCollapsed: boolean;
  regionHasMore: boolean;

  categories = [];
  allCategories: Array<any>;
  categoriesPart: Array<any>;
  categoryCollapsed: boolean;
  categoryHasMore: boolean;

  checked_categories = [];
  selected_regions = '';
  selected_categories = '';

  max_price = 100000000;
  price_start = 0;
  price_end = 'end';

  next = null;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {
    this.allRegions = [];
    this.regionsPart = [];
    this.regionCollapsed = true;
    this.allCategories = [];
    this.categoriesPart = [];
    this.categoryCollapsed = true;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.next = null;
      if (params.slug) {
        this.slug = params['slug'];

        this.checked_categories.push(params['slug']);
        this.http.get(Conf.API_URL + '/category-for-event/?slug=' + this.slug).subscribe(
            data => {
              this.category = data['results'][0];
              this.selected_categories = this.category.id;
              this.getEvent();
            },
            error => {
              console.log(error.error)
            }
        );

      } else {
        this.getEvent();
      }
    });

    this.getRegions();
    this.getCategories();

  }

  selectCategory(slug) {
    this.slug = slug;
    if (this.checked_categories.indexOf(slug) === -1) {
      this.checked_categories.push(slug);
    } else {
      this.checked_categories.splice($.inArray(slug, this.checked_categories), 1);
    }
    this.selected_categories = $('input[name="category"]:checked').map(function () {
      return $(this).val();
    }).get().join(',');
    this.getEvent()
  }


  getRegions() {
    this.http.get(Conf.API_URL + '/get-joined-areas/?category=what-is-on').subscribe(
        data => {
          this.allRegions = data['results'];
          this.regionHasMore = this.allRegions.length > 10;
          this.regionsPart = JSON.parse(JSON.stringify(this.allRegions)).slice(0, 10);
          this.regions = this.regionsPart;
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategories() {
    this.http.get(Conf.API_URL + '/category-for-event/?show_all&count=0').subscribe(
        data => {
            this.allCategories = data['results'];
            this.categoryHasMore = this.allCategories.length > 10;
            this.categoriesPart = JSON.parse(JSON.stringify(this.allCategories)).slice(0, 10);
            this.categories = this.categoriesPart;
        },
        error => {
          console.log(error.error)
        }
    );
  }

  choseRegion() {
    this.selected_regions = $('input[name="location"]:checked').map(function () {
      return $(this).val();
    }).get().join(',');
    this.getEvent();
  }

  choseRange(e) {
    this.price_start = e.from;
    this.price_end = e.to;
    this.getEvent();
  }

  getEvent() {
    var url = Conf.API_URL + '/events/?category=' + this.selected_categories +
        '&location=' + this.selected_regions;

    if (this.price_end !== 'end') {
      url += '&price_start=' + this.price_start + '&price_end=' + this.price_end;
    }

    this.http.get(url).subscribe(
        data => {
          this.events = data['results'];
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  loadMore() {
    this.http.get(this.next).subscribe(
        data => {
          this.events = this.events.concat(data['results']);
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  firstParagraph(html) {
    return FunctionsService.firstParagraph(html)
  }

    showMore(type: string): void {
        switch (type) {
            case 'region': {
                this.regions = this.regionCollapsed ? this.allRegions : this.regionsPart;
                this.regionCollapsed = !this.regionCollapsed;
                break;
            }
            case 'category': {
                this.categories = this.categoryCollapsed ? this.allCategories : this.categoriesPart;
                this.categoryCollapsed = !this.categoryCollapsed;
                break;
            }
        }
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/whats-on-list/whats-on-list.component.ts